// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ElementLibrary-EditSubjectLine--title h3{margin-bottom:1.125rem}`, "",{"version":3,"sources":["webpack://./src/components/EditorMenus/ElementLibrary/EmailViews/EditEmailDetails.scss"],"names":[],"mappings":"AAAA,0CACE,sBAAA","sourcesContent":[".ElementLibrary-EditSubjectLine--title h3 {\n  margin-bottom: 1.125rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
